import React from "react";
import Sidebar from "../admin/sidebar/Sidebar";
import AddProject from "../admin/projectAdd/AddProject";

function AddProjectPage() {
  return (
    <div>
      <Sidebar/>
      <AddProject />
    </div>
  );
}

export default AddProjectPage;
